import {useCallback} from "react";
import moment from "moment/moment";
import {setLoading} from "../../useAppPullState";
import {addBooking} from "../../api/booking";
import {syncWithServer} from "../actions/syncWithServer";
import {toast} from "react-toastify";
import {ModalStore} from "../NewBooking";
import {AddBookingStore, resetForm} from "../modal/Booking";
import {generateUuid} from "../utils/generateUuid";

export function useAddBookingSubmit(data, course) {
    const {
        firstName,
        lastName,
        memberId,
        unknown,
        phone,
        isPaid
    } = AddBookingStore.useState();
    return useCallback(e => {
        e.preventDefault();
        const model = {
            firstName,
            lastName,
            memberId,
            unknown,
            phone,
            isPaid,
            docName: generateUuid(),
            date: data.date,
            user: data.auth,
            course: course,
            timeStamp: moment(
                data.date.substring(3, 5) + "/" + data.date.substring(0, 2) + "/" + data.date.substring(6, 11)
            ).valueOf(),
            createdDateTime: moment().valueOf(),
            inAdvanceBooking:
                moment(data.date.substring(3, 5) + "/" + data.date.substring(0, 2) + "/" + data.date.substring(6, 11)).valueOf() >
                moment().valueOf(),
        };
        setLoading(true);
        addBooking(model, () => {
            syncWithServer()
            resetForm();
            toast.success("pelioikeus varattu");
        });
        ModalStore.update(s => {
            s.showMemberModal = false;
        });
    }, [firstName,
        lastName,
        memberId,
        unknown,
        phone,
        isPaid])


}
